import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';
import useKycStatus from '../dashboardLoading/useKycStatus';
import useBusinessInfo from './useBusinessInfo';

const useSubmitKyc = () => {
  const modalContext = useContext(ModalContext);
  const { businessInfo } = useBusinessInfo();
  const { kycStatus } = useKycStatus();
  const { kycDirectorOne, kycDirectorTwo } = useAppSelector((state) => state.kycInformationData);
  // const { authData } = useAppSelector((state) => state.auth);
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onSubmitKycError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while submitting KYC information',
    );
  };

  const onSubmitKycSuccess = ({ data, message }: SuccessHttpResponse<any>) => {
    toast.success(message ?? 'KYC information submitted successfully');
    modalContext?.setShowSuccessComponent(true);
    businessInfo();
    kycStatus();
  };

  const submitKyc = () => {
    const formData = new FormData();

    const { directorOneName, directorOneIdentificationType, directorOneId } = kycDirectorOne;
    const { directorTwoName, directorTwoIdentificationType, directorTwoId } = kycDirectorTwo;

    // Director One is always required
    formData.append('directorOneName', directorOneName);
    formData.append('directorOneIdentificationType', directorOneIdentificationType);
    // formData.append('id', authData?.user?.id ?? '');

    if (directorOneId?.length > 0 && directorOneId[0] instanceof File) {
      formData.append('directorOneId', directorOneId[0], directorOneId[0].name);
    } else {
      console.warn('No valid directorOneId provided');
    }

    // Only include Director Two data if provided
    const hasDirectorTwoData = directorTwoName || directorTwoIdentificationType || (directorTwoId?.length ?? 0) > 0;

    if (hasDirectorTwoData && directorTwoName && directorTwoIdentificationType) {
      formData.append('directorTwoName', directorTwoName);
      formData.append('directorTwoIdentificationType', directorTwoIdentificationType);

      if (directorTwoId && directorTwoId.length > 0 && directorTwoId[0] instanceof File) {
        formData.append('directorTwoId', directorTwoId[0], directorTwoId[0].name);
      }
    }


    const url: HttpConfig = {
      url: 'api/v1/company/kyc/apply',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    request(url, onSubmitKycSuccess, setLoading, onSubmitKycError);
  };

  return { submitKyc, loading };
};

export default useSubmitKyc;
